import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

import CommonTabList from 'components/common/tabs/CommonTabList';
import CommonTabItem from 'components/common/tabs/CommonTabItem';
import FontSelector
  from 'components/dashboard/appearance-content/FontSelector/index';

import { latinFonts } from './latinFonts';
import { cyrillicFonts } from './cyrillicFonts';

import './AppearanceFontStyle.css';

function AppearanceFontStyle(props) {
  const { setCustomMode } = props;
  const { t, i18n } = useTranslation();

  const [activeTab, setActiveTab] = useState(i18n.language === 'ru' ? 'cyrillic' : 'latin');

  return (
    <div className="appearance-font-style__component">
      <div className="tabs-container">
        <CommonTabList>
          <CommonTabItem
            active={activeTab === 'latin'}
            tabName={t('Latin Fonts')}
            onClick={() => { setActiveTab('latin'); }}
          />
          <CommonTabItem
            active={activeTab === 'cyrillic'}
            tabName={t('Cyrillic Fonts')}
            onClick={() => { setActiveTab('cyrillic'); }}
          />
        </CommonTabList>
      </div>

      <div className="content-wrapper">
        {activeTab === 'latin' &&
          <FontSelector
            key="latin-font-selector-key"
            setCustomMode={setCustomMode}
            fonts={latinFonts}
          />
        }

        {activeTab === 'cyrillic' &&
          <FontSelector
            key="cyrillic-font-selector-key"
            setCustomMode={setCustomMode}
            fonts={cyrillicFonts}
          />
        }
      </div>
    </div>
  );
}

AppearanceFontStyle.propTypes = {
  setCustomMode: PropTypes.func.isRequired,
};

export default AppearanceFontStyle;
